// Core
import { useCallback, useState } from 'react';
import { useQuery } from 'react-query';

// Chakra
import {
  Text,
  useColorModeValue,
  Divider,
  Button,
  Flex,
  Table,
  Thead,
  Tr,
  Td,
  Tbody,
} from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';

// Components
import NotFound from 'views/Dashboard/404.js';
import Pagination from '../../../components/Pagination';
import { useHistory } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa6';
import Card from '../../../components/Card/Card';
import TableSkeleton from '../../../components/TableSkeleton';
import usePermissionStatusByKey from '../../../hooks/usePermissionStatusByKey';

const Partner = () => {
  const history = useHistory();
  const borderColor = useColorModeValue('blue.50', 'rgba(255, 255, 255, 0.10)');

  const textColor = useColorModeValue('gray.700', 'white');
  const paddingTd = '16px 0 16px 24px';
  const [offset, setOffset] = useState(0);
  const [partners, setPartners] = useState([]);
  const [partnersMeta, setPartnersMeta] = useState([]);
  const limit = 25;

  const isPartners = usePermissionStatusByKey('GET:/admin/partners');

  const { isFetching, refetch } = useQuery({
    queryKey: ['partners', offset, isPartners],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      if (isPartners) {
        const params = {
          limit,
          offset,
        };

        const response = await apiService.getPartners(params);
        setPartners(response.data);
        setPartnersMeta(response.meta);
      }

      return true;
    },
    retry: false,
    refetchInterval: 30000,
  });

  const onNewButtonClicked = useCallback(() => {
    history.push('/partners/new');
  }, [history]);

  const handleEditOpen = useCallback(
    (plan) => {
      history.push(`/partners/${plan.id}`);
    },
    [history],
  );

  const handleDelete = useCallback(
    async (item) => {
      await apiService.deleteWheel(item);
      refetch();
    },
    [refetch],
  );

  const isPartner = usePermissionStatusByKey('GET:/admin/partners/:id');
  const isCreatePartners = usePermissionStatusByKey('POST:/admin/partners');

  return (
    <>
      <Flex justifyContent="space-between" alignItems="center">
        <Text
          fontSize="40px"
          fontStyle="normal"
          fontWeight="700"
          color={textColor}
          mb="0px"
          className="page-name"
        >
          Partners
        </Text>

        {isCreatePartners && (
          <Button
            variant="submit-ms"
            maxW="140px"
            w="100%"
            onClick={onNewButtonClicked}
            leftIcon={<FaPlus />}
          >
            Create
          </Button>
        )}
      </Flex>

      <Divider
        opacity="1"
        mr="2px"
        borderColor={borderColor}
        borderTopWidth="1px"
        borderBottomWidth="0"
        mb="32px"
      />

      {isPartners && (
        <>
          {isFetching ? (
            <TableSkeleton rowCount={5} />
          ) : partners.length > 0 ? (
            <Card padding={'8px'}>
              <Table color={textColor}>
                <Thead>
                  <Tr>
                    <Td>
                      <Text variant="title-md" p="0 0 6px 0">
                        Name
                      </Text>
                    </Td>
                    <Td>
                      <Text variant="title-md" p="0 0 6px 0">
                        Email
                      </Text>
                    </Td>
                    <Td>
                      <Text variant="title-md" p="0 0 6px 0">
                        Phone
                      </Text>
                    </Td>
                    <Td>
                      <Text variant="title-md" p="0 0 6px 0">
                        Location Address
                      </Text>
                    </Td>
                  </Tr>
                </Thead>
                <Tbody>
                  {partners.map((row) => {
                    return (
                      <Tr
                        onClick={() => {
                          if (isPartner) {
                            handleEditOpen(row);
                          }
                        }}
                        _last={{
                          '& td': {
                            borderBottom: 'none !important',
                          },
                        }}
                        key={row.id}
                        border="unset"
                        className="cursor-tr"
                      >
                        <Td verticalAlign="center" p={paddingTd}>
                          <Text variant="text" color={textColor}>
                            {row?.name}
                          </Text>
                        </Td>
                        <Td verticalAlign="center" p={paddingTd}>
                          <Text variant="text" color={textColor}>
                            {row?.email}
                          </Text>
                        </Td>
                        <Td verticalAlign="center" p={paddingTd}>
                          <Text variant="text" color={textColor}>
                            {row?.phone}
                          </Text>
                        </Td>
                        <Td verticalAlign="center" p={paddingTd}>
                          <Text variant="text" color={textColor}>
                            {row?.locationAddress}
                          </Text>
                        </Td>
                        {/*<Td verticalAlign="center" p={paddingTd}>*/}
                        {/*  <DeleteIcon color="#DE3730" fontSize="24px" />*/}
                        {/*</Td>*/}
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </Card>
          ) : (
            <NotFound text="Not Found" />
          )}

          <Pagination
            meta={partnersMeta ?? { limit, offset, total: 0 }}
            isLoadingPage={isFetching}
            currentPage={Math.floor(offset / limit) + 1}
            onPageChange={(newOffset) => setOffset(newOffset)}
          />
        </>
      )}

      {/*<Attention*/}
      {/*  variant="remove"*/}
      {/*  handle={() => handleDelete(object)}*/}
      {/*  isOpen={isOpen}*/}
      {/*  onOpen={onOpen}*/}
      {/*  onClose={onClose}*/}
      {/*/>*/}
    </>
  );
};

export default Partner;
